import { createFileRoute } from '@tanstack/react-router';
import { LocalizedPage, loadLocalizedPage, localizedPageHead } from '~/lib/localized-page';

export const Route = createFileRoute('/$locale/')({
  loader: ({ params }) => loadLocalizedPage(params.locale, '/'),
  head: ({ loaderData }) => localizedPageHead(loaderData),
  component: LocalizedRootPage,
});

function LocalizedRootPage() {
  return <LocalizedPage data={Route.useLoaderData()} />;
}
